import * as yup from "yup";

import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedSnackbar,
	RHookFormTextFieldWithLabel,
	SingleColumnLayout,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import {
	CLIENT_SETUP_SCREEN_SLUG,
	INITIAL_SNACKBAR_DATA,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import {
	IGetListRequest,
	IResponse,
	IServerError,
} from "../../../../models/common";
import React, { useEffect, useMemo, useState } from "react";
import { formatDate, sortDDLByLabel, useNavigateToLogout } from "../../../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { AccountantService } from "../../../../services";
import { BasicSetupFormToolbar } from "../../../BasicSetupFormToolbar";
import { CityService } from "../../../../services/CityService";
import { CountryService } from "../../../../services/common/CountryService";
import { GeneralSettingsService } from "../../../../services/GeneralSettingsService";
import { Grid } from "@mui/material";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IRoleAssignment } from "../../../../models";
import { RoleAssignmentDetailPanel } from "./Panles/RoleAssignmentDetailPanel";
import { RoleAssignmentService } from "../../../../services/RoleManagementServices/RoleAssignmentService";
import { RoleAssignmentSetupToolbar } from "./RoleAssignmentSetupToolbar";
import { RoleAssignmentSetupValidationSchema } from "./validator";
import { UsersService } from "../../../../services/RoleManagementServices/UsersService";
import { setSelectedActivityLogActions } from "../../../../store/actions/activityLogActions";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IRoleAssignmentSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "roleAssignment-single-data-record";

// const useGetData = (
// 	id: string | undefined,
// 	navigateToLogout: (path: string) => void
// ) =>
// 	useQuery({
// 		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
// 		queryFn: (data) => {
// 			return RoleAssignmentService.getById(id, navigateToLogout);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

const useGetusersDDL = () =>
	useQuery({
		queryKey: ["user-ddl"],
		queryFn: (data) => {
			return UsersService.getGetUserDDL();
		},
		refetchOnWindowFocus: false,
	});
const useGetAccountantAndClientsDDL = () =>
	useQuery({
		queryKey: ["accountants-clients-ddl"],
		queryFn: (data) => {
			return RoleAssignmentService.getAccountantAndClientsDDL();
		},
		refetchOnWindowFocus: false,
	});

const useGetActiveUserRolesData = (
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ['active-user-roles-detail', navigateToLogout],
		queryFn: (data) => {
			return RoleAssignmentService.getUserRoleDetails("", navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});
const useGetUserRolesData = (
	userId: string | null,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ['user-roles-detail', userId, navigateToLogout],
		queryFn: (data) => {
			return RoleAssignmentService.getUserRoleDetails(userId, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});
export const RoleAssignmentSetup: React.FC<IRoleAssignmentSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const isPendingActivityLogData = useSelector(
		(state: IAppState) => state.isLoadAxiosCall.isLoading
	);
	const clientStoreId = useSelector((state: IAppState) => state.client.id);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [isPendingData, setIsPendingData] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [roleAssignmentId, setRoleAssignmentId] = useState<any>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [provinceStateDDLinUpdate, setProvinceStateDDLinUpdate] =
		useState(undefined);
	const [cityDDLinUpdate, setCityDDLinUpdate] = useState(undefined);
	const [provinceStateLabelinUpdate, setProvinceStateLabelinUpdate] =
		useState<any>(undefined);
	const queryRoleAssignment = useQueryClient();
	const { id } = useParams();

	const [roleAssignmentRightsUpdatedData, setRoleAssignmentRightsUpdatedData] = useState(undefined);
	const [userRolesDetailDataState, setUserRolesDetailDataState] = useState(undefined);
	const [editRecordId, setEditRecordId] = useState(id);
	const [userId, setUserId] = useState(null);

	const { isPending: isSubmitting, mutate: submitFormFields } = useMutation({
		mutationFn: RoleAssignmentService.create,
		onSuccess: (res: IRoleAssignment | IServerError | IResponse | any) => {


			if (res && res.status === 201) {
				// setEditRecordId(res.id);
				queryRoleAssignment.invalidateQueries({
					queryKey: ['user-roles-detail'],
				});
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});

				// call general settings to dave default settings 
				// (async () => {
				// 	let payload = {
				// 		roleAssignmentId: res.data.id,
				// 		navigateToLogout: navigateToLogout,
				// 		repeatColumnHeading: 200,
				// 		timeFormat: 200,
				// 		employeeId: 300,
				// 		allEmployeesPaymentMethod: undefined,
				// 		vacationPayonPaidVacPay: 100,
				// 		payrollRemittancesMethod: 200,
				// 		vacationPayOnPaidVacPay: 100,
				// 		vacationPay: 200,
				// 		payoutVacationpay: 100,
				// 		commission: 100,
				// 		overtimeHours: 300,
				// 		edrFields: 200,
				// 		bonus: 200,
				// 		nonPeriodicPayment: 200,
				// 		retroactivePayIncrease: 200,
				// 		employeeSelectionInPayroll: 100,
				// 		hourlyPayRate: 100,
				// 		companyLogo: null,
				// 	};
				// 	try {
				// 		const response: any =
				// 			await GeneralSettingsService.create(
				// 				payload
				// 			);
				// 	} catch { }
				// })();
				// let path = `/roleAssignment/setup/${res.data.id}`;
				// navigate(path);
			} else if (res && res.message === "Success") {
				setSnackbarData({
					open: true,
					message: res.message,
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	// const { isPending: isPendingById, data: userRolesDetailById } = useGetData(
	// 	editRecordId,
	// 	navigateToLogout
	// );

	// let userRolesDetailByIdData: any = userRolesDetailById;


	const { isPending: isPendingActiveUserRoles, data: getActiveUserRolesDetail } = useGetActiveUserRolesData(
		navigateToLogout
	);

	let activeUserRolesDetailData: any = getActiveUserRolesDetail;

	const { isPending: isPendingUserRoles, data: getUserRolesDetail } = useGetUserRolesData(
		userId,
		navigateToLogout
	);

	let userRolesDetailData: any = getUserRolesDetail;

	useEffect(() => {
		if (userRolesDetailData && userId !== null) {
			setUserRolesDetailDataState(userRolesDetailData)
		}
	}, [userRolesDetailData])

	const { isPending: isPendingusersDDL, data: usersDDL } =
		useGetusersDDL();

	const { isPending: isPendingAccountantAndClientsDDL, data: accountantAndClientsDDL } =
		useGetAccountantAndClientsDDL();


	const DEFAULT_VALUES = {

	};
	const formMethods = useForm<any>({
		resolver: yupResolver(RoleAssignmentSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES,
	});

	const buildrolesData = (formData: any) => {
		const rolesData = Object.keys(formData)
			.filter(
				(key) => key.endsWith("-roleId") && formData[key] === true
			)
			.map((key) => {
				const roleId = key.replace("-roleId", "");
				const expiresAtKey = `${roleId}-expiresAt`;
console.log("expiresAtKey", expiresAtKey)
				return {
					roleId,
					expiresAt: formatDate(formData[expiresAtKey]) || null,
				};
			});
			console.log("formData", formData)
		return rolesData;
		
	};

	const onSubmit = async (values: any) => {

		const rolesData = buildrolesData(values)


		let payload = {
			// id: id && id,
			userId: values.userId,
			rolesData: rolesData,
			accountantClients: values.accountantClients,
			navigateToLogout: navigateToLogout,

		};

		submitFormFields(payload);
	};

	// useEffect(() => {

	// 	if (id && userRolesDetailByIdData) {
	// 		Object.keys(userRolesDetailByIdData).forEach((fieldName: any) => {
	// 			const fieldValue = userRolesDetailByIdData[fieldName];
	// 			formMethods.setValue(fieldName, fieldValue ?? undefined);
	// 			if (fieldName === "address") {
	// 			}
	// 		});
	// 	}
	// }, [id, userRolesDetailByIdData]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteRoleAssignmentById } = useMutation({
		mutationFn: RoleAssignmentService.delRoleAssignment,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the RoleAssignment fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			// formMethods.reset();
			let path = `/role-management/role-assignment/setup`;
			navigate(path);
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteRoleAssignmentField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				roleAssignmentId: roleAssignmentId,
				navigateToLogout: navigateToLogout,
			};
			deleteRoleAssignmentById(delPayload);
			setDialogOpen(false);
		}
	};

	// const onDeleteClicked = () => {
	// 	setDialogOpen(true);
	// 	setSingleDelete(true);
	// 	if (userRolesDetailByIdData) {
	// 		setRoleAssignmentId(userRolesDetailByIdData.id);
	// 	}
	// };

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/role-management/role-assignment/setup`;
		navigate(path);
		setUserRolesDetailDataState(undefined)
	};

	const onUserSelectionChangeHandler = (e: any) => {

		if (e.value === "") {
			setUserId(null)
			setUserRolesDetailDataState(undefined)
		} else {
			setUserId(e.value)
		}
		// setUserId(e.value)
	}

	// const { isPending, data } = useAccountants({
	//   search_query: "",
	//   order_by: "acc_title",
	//   order_direction: "asc",
	//   page: 1,
	//   size: 25,
	// });
	// const accountantList: any = data;
	// const enhanceData = (data: any[]): any[] => {
	// 	return data.map((item) => {
	// 		const enhancedItem = {
	// 			...item,
	// 			expanded: false,
	// 		};
	// 		return enhancedItem;
	// 	});
	// };
	const expandedLabels = ["Role Management", "Role Assignment"];
	const expandedLabelsForAdmin = ["User Management", "Role Assignment"];
	const expandedHomeRoleAssignmentSetupOrRoleAssignmentSetupItem = "Setup"; // Special case for "RoleAssignmentSetup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			if (clientStoreId && clientStoreId !== "") {
				let isExpanded = expandedLabelsForAdmin.includes(item.label);
				if (
					parentLabel === "Role Assignment" &&
					item.label === expandedHomeRoleAssignmentSetupOrRoleAssignmentSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedHomeRoleAssignmentSetupOrRoleAssignmentSetupItem && "/role-management/role-assignment/setup",
				};
				return enhancedItem;
			} else {
				let isExpanded = expandedLabels.includes(item.label);
				if (
					parentLabel === "Role Assignment" &&
					item.label === expandedHomeRoleAssignmentSetupOrRoleAssignmentSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedHomeRoleAssignmentSetupOrRoleAssignmentSetupItem && "/role-management/role-assignment/setup",
				};
				return enhancedItem;
			}
		});
	};
	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: id ? id : "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: CLIENT_SETUP_SCREEN_SLUG,
		// 		accountantName: roleAssignmentName,
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);


	return (
		<Grid sx={{ mt: "1.7rem" }}>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingData ||
					// isPendingById ||
					isDeleting ||
					isPendingActivityLogData ||
					provinceDDLLoading ||
					isPendingusersDDL ||
					isPendingUserRoles ||
					isPendingActiveUserRoles ||
					isPendingAccountantAndClientsDDL
				}
				testId="accountant Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteRoleAssignmentField}
				cancelActionHandler={onCloseHandler}
				testId="accountant-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid
						container
						size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
						sx={{
							background: "#fff",
							border: "1px solid #e5e7eb",
							borderBottom: 0,
							borderRadius: "2px 2px 0 0",
							padding: "31px 20px 0 20px",
						}}
						columnSpacing={2}
					>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
							<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
								<EnhancedDropDownRHFWithLabel
									selectName="userId"
									testId={`user-list`}
									items={usersDDL ?? []}
									showEmpty
									label="Users"
									onSelectionChangeHandler={onUserSelectionChangeHandler}
								/>
							</Grid>
							<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
								<></>
							</Grid>
						</Grid>
					</Grid>

					{/* <TwoColumnLayout
				toolbar={<></>}
				leftColumnContent={
					<>
						<StandardPanel
							title="ROLE RIGHTS"
							testId={`roleAssignment-info`}
							variant="outlined"
							borderHide={true}
						>
							<RoleAssignmentRightsDataTable
								roleAssignmentRightsUpdatedData={(data: any) =>
									setRoleAssignmentRightsUpdatedData(data)
								}
								roleAssignmentRightsDataItems={userRolesDetailByIdData && userRolesDetailByIdData.roleAssignment}
							// roleAssignmentRightsDataItems={[]}
							/>
						</StandardPanel>
					</>
				}
				rightColumnContent={
					<>
						<StandardPanel
							title="ROLE PERMISSIONS"
							testId={`roleAssignment-address-info`}
							variant="outlined"
							borderHide={true}
						>
							<RoleAssignmentPermissionsDataTable
								roleAssignmentPermissionsUpdatedData={(data: any) =>
									setRoleAssignmentPermissionsUpdatedData(data)
								}
								roleAssignmentPermissionsDataItems={userRolesDetailByIdData && userRolesDetailByIdData.permissions.items}
								roleAssignmentPermissionsHeaderColumns={userRolesDetailByIdData && userRolesDetailByIdData.permissions?.headerColumns}
							// roleAssignmentRightsDataItems={[]}
							/>
						</StandardPanel>
					</>
				}
				testId="t4-slip-setup-form"
			/> */}
					<SingleColumnLayout toolbar={<></>} testId={"undefined"} showFullDiaplay={true}>
						<StandardPanel
							title="ROLE ASSIGNMENT DETAILS"
							testId={`role-assignment`}
							variant="outlined"
							borderHide={true}
						>
							<RoleAssignmentDetailPanel
								activeUserRolesDetailData={activeUserRolesDetailData}
								selectedUserRolesDetail={userRolesDetailDataState}
								formMethods={formMethods}
								accountantAndClientsDDL={accountantAndClientsDDL && sortDDLByLabel(accountantAndClientsDDL)}
							/>
						</StandardPanel>
					</SingleColumnLayout>
					<RoleAssignmentSetupToolbar
						onResetClicked={onResetClicked}
						isSubmitting={isSubmitting}
						id={id}
					// onDeleteClicked={onDeleteClicked}
					/>
				</form>
			</FormProvider>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
